<script>
  import { getContext } from 'svelte';
  import { currentSorts, availableSorts } from './stores/sort-order-store.js';
  import Icon from './Icon.svelte';

  export let device;

  const collection = getContext('collection');

  function changeSort() {
    currentSorts.set(
      $availableSorts.find(sort => sort.label === selectedSortLabel)
    );
  }

  const sortOptions = $availableSorts
    .filter(sort => {
      // Don't show Relevance on collections, but do show it on search
      if (sort.label === "Relevance" && collection !== null) {
        return false;
      }
      // Don't show Recommended on search
      if (sort.label === "Recommended" && collection === null) {
        return false;
      }
      // Don't show Recommended on collections without manual sort order turned on
      if (sort.label === "Recommended" && typeof collection === "object" && collection !== null && collection.sort_order !== "manual") {
        return false;
      }
      return true;
    })
    .map(sort => {
      if (sort.label === "Recommended" && collection !== null) {
        sort.sortBy = sort.sortBy.replace("XXX", collection.id);
      }
      return sort;
    });

  currentSorts.set(sortOptions[0]);
  let selectedSortLabel = $currentSorts.label;
</script>

{#if currentSorts}
  {#if device === 'mobile'}
    <div class="text-brand-blue relative">
      <select
        name="sort"
        bind:value={selectedSortLabel}
        on:change={changeSort}
        class="btn btn--solid bg-lighter-grey border-lighter-grey text-left w-full appearance-none"
      >
        {#each sortOptions as sort}
          <option value="{sort.label}">{sort.label}</option>
        {/each}
      </select>

      <Icon icon="small-arrow-down" classes="absolute right-2 top-1/2 translate-y-[-50%] pointer-events-none" h="12" w="12" />
    </div>
  {:else}
    <div class="flex items-center relative">
      <select
        name="sort"
        bind:value={selectedSortLabel}
        on:change={changeSort}
        class="bg-white appearance-none text-b2 font-body font-normal leading-none pr-2"
      >
        {#each sortOptions as sort}
          <option value="{sort.label}">{sort.label}</option>
        {/each}
      </select>

      <Icon icon="small-arrow-down" classes="inline-block absolute right-0 pointer-events-none" h="16" w="16" />
    </div>
  {/if}
{/if}
